import { createTheme } from '@mui/material/styles';
import { remCalc } from 'utils/remCalc';
import breakpoints from 'utils/breakpoints';
import mixins from 'utils/mixins';
import { getColor } from 'utils/colors';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.comparisonCardsContentLink__section': {
		...theme.mixins.layout_styles,
		'.comparisonCardsContentLink__navigation': {
			'.comparisonCardsContentLink__bullets': {
				display: 'flex',
				flexDirection: 'row',
				transition: '300ms opacity',
				transform: 'translate3d(0, 0, 0)',
				zIndex: '10',
				paddingBottom: remCalc('48px'),
				[theme.breakpoints.up('md')]: {
					paddingBottom: remCalc('80px'),
				},
				'.comparisonCardsContentLink__bullet': {
					flex: 'auto',
					height: remCalc(4),
					background: getColor('ivory',400),
					transition: 'all .2s',
					border: 'none',
					[theme.breakpoints.up('lg')]: {
						'&:hover': {
							cursor: 'pointer',
						}
					},
					'&.comparisonCardsContentLink__bullet-active': {
						background: getColor('ivory',500),
					}
				}
			}
		},
		'.comparisonCardsContentLink__content': {
			paddingBottom: remCalc('48px'),
			[theme.breakpoints.up('md')]: {
				paddingBottom: remCalc('80px'),
			},
			'.comparisonCardsContentLink__title_wrapper': {
				display: 'flex',
				flexDirection: 'column',
				gap: remCalc('16px'),
				'.comparisonCardsContentLink__subtitle': {
					margin: '0',
					color: getColor('ivory',700),
					fontFamily: 'var(--heading-font)',
					fontSize: remCalc('18px'),
					fontStyle: 'normal',
					fontWeight: '400',
					lineHeight: remCalc('24px'),
					letterSpacing: remCalc('0.5px'),
					textTransform: 'uppercase',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('20px'),
						lineHeight: remCalc('26px'),
					}
				},
				'.comparisonCardsContentLink__title': {
					margin: '0',
					color: getColor('ivory',700),
					fontFamily: 'var(--heading-font)',
					fontSize: remCalc('32px'),
					fontStyle: 'normal',
					fontWeight: '400',
					lineHeight: remCalc('40px'),
					letterSpacing: remCalc('0.5px'),
					textTransform: 'uppercase',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('61px'),
						lineHeight: remCalc('67px'),
					}
				}
			},
			'.comparisonCardsContentLink__body_wrapper': {
				display: 'flex',
				flexDirection: 'column',
				gap: remCalc('16px'),
				alignItems: 'flex-start',
				'.comparisonCardsContentLink__description': {
					margin: '0',
					color: getColor('ivory',700),
					fontFamily: 'var(--body-font)',
					fontSize: remCalc('18px'),
					fontStyle: 'normal',
					fontWeight: '400',
					lineHeight: remCalc('24px'),
					letterSpacing: remCalc('0.5px'),
					textTransform: 'none',
					[theme.breakpoints.up('lg')]: {
						fontSize: remCalc('16px'),
						lineHeight: remCalc('22px'),
					}
				},
				'.comparisonCardsContentLink__link': {
					margin: '0',
					color: getColor('ivory',600),
					fontFamily: 'var(--heading-font)',
					fontSize: remCalc('20px'),
					fontStyle: 'normal',
					fontWeight: '500',
					lineHeight: remCalc('24px'),
					letterSpacing: remCalc('0.5px'),
					textTransform: 'uppercase',
					transition: 'all var(--transition-duration)',
					textDecoration: 'none',
					display: 'inline-flex',
					alignItems: 'center',
					borderBottom: '1px solid transparent',
					[theme.breakpoints.up('lg')]: {
						'&:hover': {
							color: getColor('ivory',700),
						}
					},
					'.comparisonCardsContentLink__linkText': {

					},
					'.comparisonCardsContentLink__linkText__arrow': {
						width: 0,
						height: remCalc(12),
						opacity: 0,
						marginLeft: 0,
						overflow: 'hidden',
						transform: 'translateX(-6px)',
						transition: 'width var(--transition-duration) ease, margin-left var(--transition-duration) ease, opacity var(--transition-duration-slow) ease, transform var(--transition-duration) ease',

						'svg': {
							display: 'block',
							width: remCalc(47),
							height: remCalc(12),
						},

						'svg path': {
							fill: getColor('ivory', 700),
						},
					},
					'&:focus-visible': {
						borderBottom: `1px solid ${getColor('ivory', 700)}`,
					},

					'&:focus-visible .comparisonCardsContentLink__linkText__arrow': {
						width: remCalc(47),
						marginLeft: remCalc(16),
						opacity: 1,
						transform: 'translateX(0)',
					},
					'@media (hover: hover) and (pointer: fine)': {
						'&:hover': {
							borderBottom: `1px solid ${getColor('ivory', 700)}`,
						},
						'&:hover .comparisonCardsContentLink__linkText__arrow': {
							width: remCalc(47),
							marginLeft: remCalc(16),
							opacity: 1,
							transform: 'translateX(0)',
						},
					},
				}
			}
		},
		'.comparisonCardsContentLink__images_wrapper': {
			'.comparisonCardsContentLink__images_grid': {
				display: 'flex', 
				flexDirection: 'column', 
				gap: '10px',
				[theme.breakpoints.up('md')]: {
					flexDirection: 'row',
				},
				'.comparisonCardsContentLink__image': {
					minHeight: remCalc('400px'),
					height: remCalc('570px'),
					transition: 'all .7s ease-in-out',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center',
					[theme.breakpoints.down('md')]: {
						width: '100%!important',
						height: remCalc('300px'),
						minHeight: 'unset',
					}
				}
			}
		}
	}
}

const styles = {};

export default styles;